export const API_BREAKPOINT = "wss://bankrotstvork.ru:8880";
